export const socialSelector = {
  socialSelectorViewStories: "Ver historias",
  socialSelectorGoToProfile: "Ir al perfil",
  socialSelectorGoToCommunity: "Ir a comunidad",
  socialSelectorCancel: "Cancelar",
  socialSelectorOptionsFor: "Opciones para {{name}}",
  socialSelectorLabelAyg: "Plataforma oficial",
  socialSelectorLabelProvider: "Proveedor de juegos",
  socialSelectorLabelUser: "Jugador",
  socialSelectorLabelCommunity: "Comunidad AYG",
  socialSelectorPlayInFeed: "Jugar en el feed",
};
